import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { CreationToolSourceFile } from '../../types'
import CreationToolOutputType from '../../types/output-type'
import CreationToolSourceEditor from '../../types/source-editor'
import Manager from './manager'
import Navigation from './navigation'
import Panel from './panel'
import Preview from './preview'
import { SourceEditorEdits, SourceEditorWatermark } from './types'

const Container = styled.div`
    display: flex;
    margin: 0 auto;
    width: 100%;
`

const Wrapper = styled.div`
    margin-left: auto;
`

export type SourceEditorProps = {
    children?: ReactNode
    className?: string
    defaultEditor?: CreationToolSourceEditor
    customFontUrl?: string
    watermark?: SourceEditorWatermark
    outputType: CreationToolOutputType
    edits?: SourceEditorEdits
    source: CreationToolSourceFile
    onUpdate?: (edits?: SourceEditorEdits) => void
    onDone: (edits?: SourceEditorEdits) => void
}

const CreationToolsSourceEditor = ({
    children,
    className,
    defaultEditor,
    customFontUrl,
    watermark,
    outputType,
    edits,
    source,
    onUpdate,
    onDone,
}: SourceEditorProps) => (
    <Manager
        {...{
            defaultEdits: edits,
            customFontUrl,
            watermark,
            defaultEditor,
            outputType,
            source,
            onUpdate,
        }}
    >
        <Container className={className}>
            <Wrapper>{children}</Wrapper>
            <Panel onDone={onDone}>
                <Preview />
            </Panel>
            <Navigation />
        </Container>
    </Manager>
)

export default CreationToolsSourceEditor
